import React from "react";
import Chart from "react-apexcharts";

const RecentlyCreatedDealsChart = ({ data = [] }) => {
  const dayMap = {
    1: "Sun",
    2: "Mon",
    3: "Tue",
    4: "Wed",
    5: "Thu",
    6: "Fri",
    7: "Sat",
  };

  const categories = data.map((item) => dayMap[item._id]);
  const seriesData = data.map((item) => item.count);
  const hasData = seriesData.some((x) => x > 0);

  const options = {
    chart: { type: "bar", toolbar: { show: false } },
    plotOptions: {
      bar: { borderRadius: 4, columnWidth: "45%", distributed: true },
    },
    dataLabels: { enabled: false },
    legend: { show: false },
    xaxis: {
      categories: categories,
      title: { text: "Past 7 Days" },
    },
    yaxis: { title: { text: "Lead Count" } },
    colors: ["#00E396"],
  };

  const series = [{ name: "Leads Created", data: seriesData }];

  return (
    <div className="card-body">
      <h5 className="card-title mb-4">Weekly Lead Generation</h5>
      {hasData ? (
        <Chart options={options} series={series} type="bar" height={300} />
      ) : (
        <div className="p-5 text-center text-muted">
          No activity in last 7 days
        </div>
      )}
    </div>
  );
};

export default RecentlyCreatedDealsChart;
